import * as React from "react";
import TabsNavi from "../../../../components/molecules/TabsNavi";
import StudentTag from "../../../../domains/StudentTag";
import SectionInterface from "../../../../interfaces/SectionInterface";
import SectionTagForm from "../SectionTagForm";
import SectionTagList from "../SectionTagList";
import { useIsSubmitting } from "../useIsSubmitting";

type Props = {
  section: SectionInterface;
  tags: StudentTag[];
  createTag: (targetTag: StudentTag) => void;
  updateTag: (targetTag: StudentTag) => void;
  deleteTag: (targetTag: StudentTag) => void;
};

const SectionsSettingsTags = (props: Props) => {
  const tagList = props.tags.filter((tag) => tag.type === "tag_ids");

  const onSubmitCallback = (
    type: "create" | "update" | "delete",
    targetTag: StudentTag,
  ) => {
    // react-queryのキャッシュを更新
    if (type === "create") {
      props.createTag(targetTag);
    } else if (type === "update") {
      props.updateTag(targetTag);
    } else if (type === "delete") {
      props.deleteTag(targetTag);
    }
  };

  const isSubmitting = useIsSubmitting({ sectionId: props.section.id });

  return (
    <React.Fragment>
      <TabsNavi
        tabs={[
          {
            label: "タグ",
            link: "#",
            active: true,
          },
        ]}
      />
      <SectionTagForm
        section={props.section}
        submitting={isSubmitting}
        onSubmitCallback={onSubmitCallback}
      />
      <SectionTagList
        section={props.section}
        tags={tagList}
        submitting={isSubmitting}
        onSubmitCallback={onSubmitCallback}
      />
    </React.Fragment>
  );
};

export default SectionsSettingsTags;
